import { AboutPage } from "pages/AboutPage/AboutPage"
import { DefaultPage } from "pages/DefaultPage/DefaultPage"
import { LinksPage } from "pages/LinksPage/LinksPage"
import { WorksPage } from "pages/WorksPage/WorksPage"
import { Suspense } from "react"
import { Route, Routes } from "react-router-dom"

export const RouteProvider = () => {
    return (
        <Suspense fallback={<div>Загрузка...</div>}>
            <Routes>
                <Route path={'/'} element={<DefaultPage />} />
                <Route path={'/about'} element={<AboutPage />} />
                <Route path={'/works'} element={<WorksPage />} />
                <Route path={'/links'} element={<LinksPage />} />

                {/* <Route path={'*'} element={<NotFoundPage />} /> */}
            </Routes>
        </Suspense>
    )
}